import { type SVGProps } from 'react';

export function ProfileAvatar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="currentcolor" aria-hidden="true" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        d="M10 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 7A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm0-1a4.98 4.98 0 0 0 2.18-.5l-.415-2.074A2.987 2.987 0 0 1 8 11c-.66 0-1.27-.213-1.765-.574L5.82 12.5c.659.32 1.398.5 2.18.5zm2.58-3.598.507 2.532a5 5 0 1 0-6.173 0l.506-2.532A.5.5 0 0 1 5.91 9h.358a2 2 0 0 0 3.464 0h.358a.5.5 0 0 1 .49.402z"
        clipRule="evenodd"
      />
    </svg>
  );
}
